import { useEffect, useState } from "react"

export type ImageStatus = "idle" | "loaded" | "error"

function useImageStatus(src?: string) {
  const [status, setStatus] = useState<ImageStatus>("idle")

  useEffect(() => {
    if (!src) {
      setStatus("error")
      return
    }

    const img = new Image()
    img.src = src

    img.onload = () => setStatus("loaded")
    img.onerror = () => setStatus("error")

    return () => {
      img.onload = null
      img.onerror = null
    }
  }, [src])

  return status
}

export default useImageStatus
